import React from 'react';
import PropTypes from 'prop-types';

import { Wrapper } from './styles';

const Pill = ({ Icon, label, isBlue, isRed, isYellow, isGrey, isGreen, isUniBlue }) => (
  <Wrapper isUniBlue={isUniBlue} isBlue={isBlue} isRed={isRed} isYellow={isYellow} isGrey={isGrey} isGreen={isGreen}>
    {Icon ? <Icon /> : null}
    <p>{label}</p>
  </Wrapper>
);

Pill.propTypes = {
  Icon: PropTypes.func,
  label: PropTypes.string.isRequired,
  isUniBlue: PropTypes.bool,
  isBlue: PropTypes.bool,
  isRed: PropTypes.bool,
  isYellow: PropTypes.bool,
  isGrey: PropTypes.bool,
  isGreen: PropTypes.bool
};

export default Pill;
